import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Card, Chip } from "@material-ui/core";
import { solveActivityFromSpecificTrainingAction } from "@icarius-pages/myTraining/actions";
import { ACTIVITY_STATUS_OPTIONS } from "@icarius-pages/myTraining/constants";
import SessionsContent from "./sessionsContent";
import TextContent from "./textContent";
import MediaContent from "./mediaContent";
import EvaluationContent from "./evaluationContent";
import InPersonAttemptsContent from "./inPersonAttemptsContent";
import SolveExerciseDialog from "./solveExerciseDialog";
import SolveActivityButton from "./solveActivityButton";
import Countdown from "./countdown";
import StartCountdown from "./startCountdown";
import { getLocalizedString } from "@icarius-localization/strings";
import { Alert } from "@material-ui/lab";
import StatusChip from "./statusChip";

const MainContent = (props) => {

    const {
        trainingData,
        activityData,
    } = props;

    const dispatch = useDispatch();
    const [solveExerciseDialogIsOpen, setSolveExerciseDialogIsOpen] = useState(false);

    const handleSolveActivity = (answers) => {
        dispatch(solveActivityFromSpecificTrainingAction(trainingData.id, activityData.id, answers));
    }

    const readOnly = (!trainingData.isInstructor && !trainingData.isParticipant)
        || trainingData.isInstructor
        || trainingData.isFinished
        || activityData.status !== ACTIVITY_STATUS_OPTIONS.pending;

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    borderRadius: 15,
                    padding: activityData.type === "V" ? 0 : 15,
                    display: "flex",
                    flexDirection: "column",
                    gap: 15,
                }}
            >
                <StatusChip
                    passed={activityData.passed}
                    showIcon
                />
                {
                    activityData.status === ACTIVITY_STATUS_OPTIONS.pendingCorrection &&
                    <Chip
                        label={getLocalizedString("activityPendingInstructor")}
                        style={{
                            width: "100%",
                            background: "var(--ownBlue)",
                            color: "white",
                        }}
                    />
                }
                {
                    (trainingData.isInstructor || trainingData.isParticipant) &&
                    activityData.type === "S" && activityData.status !== ACTIVITY_STATUS_OPTIONS.completed &&
                    <Alert variant="filled" severity="info" style={{ borderRadius: 15, alignItems: "center" }}>
                        {getLocalizedString(trainingData.isInstructor ? "sessionHowToCompleteAsInstructor" : "sessionHowToComplete")}
                    </Alert>
                }
                {
                    !activityData.countdown && !readOnly &&
                    <StartCountdown
                        trainingData={trainingData}
                        activityData={activityData}
                    />
                }
                {
                    Boolean(activityData.countdown) &&
                    <Countdown
                        trainingData={trainingData}
                        activityData={activityData}
                    />
                }
                <MediaContent
                    data={activityData.media}
                />
                <TextContent
                    key={`content_${activityData.currentAttempt}_${activityData?.countdown?.currentTime || 0}`} // para que recargue el state cuando viene otro intento o arranca el countdown porque puede venir data distinta
                    data={activityData.content}
                />
                <EvaluationContent
                    key={`eval_${activityData.currentAttempt}_${activityData?.countdown?.currentTime || 0}`} // para que recargue el state cuando viene otro intento o arranca el countdown porque puede venir data distinta
                    readOnly={readOnly}
                    isInstructor={trainingData.isInstructor}
                    data={activityData.evaluation}
                    handleSubmit={handleSolveActivity}
                    renderSolveButton={(onClick) => {
                        return (
                            <SolveActivityButton
                                readOnly={readOnly}
                                activityData={activityData}
                                onClick={onClick}
                            />
                        )
                    }}
                />
                <SessionsContent
                    data={activityData.sessions}
                    trainingData={trainingData}
                    activityData={activityData}
                />
                <InPersonAttemptsContent
                    data={activityData.attemptsConfig}
                    trainingData={trainingData}
                    activityData={activityData}
                />
                {
                    Boolean(activityData.type === "P" && !activityData.isInPersonActivity && activityData.content) &&
                    <SolveActivityButton
                        readOnly={readOnly}
                        activityData={activityData}
                        onClick={() => setSolveExerciseDialogIsOpen(true)}
                    />
                }
            </Card>
            {
                solveExerciseDialogIsOpen &&
                <SolveExerciseDialog
                    open={solveExerciseDialogIsOpen}
                    activityData={activityData}
                    handleSubmit={handleSolveActivity}
                    handleClose={() => setSolveExerciseDialogIsOpen(false)}
                />
            }
        </>
    )
}

export default MainContent;